import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { selectOrganization } from '../../../Actions/Login.action';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import { translate } from '../../../Services/translation';
import Button from '../../Button';
import Dropdown from '../../Dropdown';
import { StyledLogin } from '../styles/LoginForm.styles';

const StyledOrganizationForm = styled(StyledLogin)`
  .title {
    margin-bottom: 2.4rem;
  }

  .button {
    margin-top: 3.2rem;
  }
`;

const LoginSelectOrganization = () => {
  const dispatch = useDispatch();
  const { organizations, isLoading } = useTypedSelector((state) => state.login);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState<
    string | undefined
  >();

  return organizations ? (
    <StyledOrganizationForm>
      <h3 className="title">{translate('login.choose-organization')}</h3>
      <Dropdown
        placeholder={translate('login.choose-organization')}
        onChange={({ value }) => setSelectedOrganizationId(value)}
        options={organizations.map((org) => ({
          value: org.systemId,
          label: org.name,
        }))}
        disabled={isLoading}
        selectedValue={selectedOrganizationId}
      />
      <Button
        btnType="primary"
        btnSize="large"
        fullwidth={true}
        className="button"
        onClick={() =>
          selectedOrganizationId &&
          dispatch(selectOrganization(selectedOrganizationId))
        }
        disabled={isLoading || !selectedOrganizationId}
      >
        {!isLoading && translate('general.select')}
        {isLoading && translate('general.loading')}
      </Button>
    </StyledOrganizationForm>
  ) : null;
};

export default LoginSelectOrganization;
